/**
 * Common border tokens used for web and mobile.
 */
export const borderWidth = {
  thin: 1,
  thick: 2,
};

export const borderRadius = {
  small: 4,
  medium: 8,
  large: 16,
};
